import { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { useLang, LANGUAGES } from "@/context/LanguageContext";

export function LanguageSwitcher({ testid = "language-switcher" }) {
    const { lang, setLang } = useLang();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener("mousedown", onClick);
        return () => document.removeEventListener("mousedown", onClick);
    }, []);

    const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

    return (
        <div className="relative" ref={ref}>
            <button
                data-testid={testid}
                onClick={() => setOpen((v) => !v)}
                className="eyebrow flex items-center gap-2 rounded-full border border-border px-4 py-2 text-obsidian/70 hover:text-obsidian hover:border-obsidian transition-colors duration-300"
            >
                <Globe size={14} /> {current.label}
            </button>
            {open && (
                <div className="absolute right-0 mt-2 w-40 glass border border-border rounded-lg overflow-hidden shadow-lg z-50" data-testid="language-menu">
                    {LANGUAGES.map((l) => (
                        <button
                            key={l.code}
                            data-testid={`lang-option-${l.code}`}
                            onClick={() => { setLang(l.code); setOpen(false); }}
                            className={`w-full flex items-center justify-between px-4 py-3 text-sm transition-colors hover:bg-secondary ${lang === l.code ? "text-cyan font-semibold" : "text-obsidian"}`}
                        >
                            {l.full} {lang === l.code && <Check size={14} />}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
